import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Mail, ArrowLeft } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/forgot-password`, {
        email: email
      });

      if (response.data.success) {
        setMessage('Password reset link sent! Check your email.');
        setSubmitted(true);
      }
    } catch (err) {
      if (err.response?.status === 429) {
        setError('Too many requests. Please try again later.');
      } else {
        setError(err.response?.data?.detail || 'Failed to send reset email. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-content bg-[#050505] min-h-screen">
      <Navbar />
      
      <section className="py-32">
        <div className="max-w-md mx-auto px-6">
          {/* Back Button */}
          <Link 
            to="/login" 
            className="flex items-center gap-2 text-gray-400 hover:text-red-500 transition-colors mb-8"
          >
            <ArrowLeft size={20} />
            Back to Login
          </Link>

          {/* Header */}
          <div className="mb-8">
            <h1 className="text-4xl md:text-5xl font-black uppercase mb-2">
              <span className="text-red-500">FORGOT</span> PASSWORD
            </h1>
            <p className="text-gray-400 font-['Rajdhani'] text-lg">
              Enter your email to receive a password reset link
            </p>
          </div>

          {/* Form */}
          {!submitted ? (
            <form onSubmit={handleSubmit} className="bg-[#0A0A0A] border border-white/10 p-8">
              <div className="mb-6">
                <label className="text-sm uppercase tracking-wider text-gray-400 mb-2 block">
                  EMAIL ADDRESS
                </label>
                <div className="relative">
                  <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500" size={20} />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="your@email.com"
                    className="w-full bg-black border border-white/10 focus:border-red-500 text-white h-12 pl-12 pr-4 font-['Rajdhani'] transition-all"
                  />
                </div>
              </div>

              {error && (
                <div className="mb-6 p-4 bg-red-900/20 border border-red-500/50 text-red-500 text-sm">
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-red-600 hover:bg-red-700 text-white font-black py-4 uppercase tracking-wider transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'SENDING...' : 'SEND RESET LINK'}
              </button>
            </form>
          ) : (
            <div className="bg-[#0A0A0A] border border-green-500/50 p-8">
              <div className="text-center">
                <div className="mb-4">
                  <Mail className="mx-auto text-green-500" size={48} />
                </div>
                <h2 className="text-2xl font-bold text-white mb-4">CHECK YOUR EMAIL</h2>
                <p className="text-gray-400 mb-6">
                  {message}
                </p>
                <p className="text-sm text-gray-500 mb-8">
                  The link will expire in 15 minutes.
                </p>
                <Link 
                  to="/login"
                  className="inline-block bg-red-600 hover:bg-red-700 text-white px-8 py-3 uppercase tracking-wider transition-all"
                >
                  BACK TO LOGIN
                </Link>
              </div>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ForgotPasswordPage;